<template>
    <v-container>
        <v-row class="contentRow">
            <v-col>
                <h1 class="text-left darkColor--text">Onsite Auditor View</h1>
			</v-col>
			<v-col cols="12">
				<p class="darkColor--text">
					This is your overview of onsite-audits that you have been sent.
					Pending templates and pending audits await your attention.
					<br />Completed templates have been approved. Completed audits have been submitted, you will not be notified of any future status changes.
				</p>
			</v-col>
            <v-tabs background-color="transparent" light centered icons-and-text>
                <v-tab>
                    Templates
                    <v-icon>fas fa-list-ul</v-icon>
                </v-tab>
                <v-tab class="submitted">
                    Audits
                    <v-icon>fas fa-list-check</v-icon>
                </v-tab>
				<v-tab-item>
					<br>
					<v-row>
						<v-col>
							<v-card elevation="0" outlined>
								<v-tabs background-color="transparent" color="orangeButton" v-model="onsiteTemplates">
									<v-tab key="pendingTemplate">
										Pending 
									</v-tab>
									<v-tab key="completedTemplate">
										Approved
									</v-tab>
									<v-tab-item key="pendingTemplate">
										<v-card-title class="text-center justify-left py-6">
											<h3 class="darkColor--text">Pending Onsite Templates</h3>
										</v-card-title>
										<v-data-table
											:loading="loading"
											theme--
											light
											:headers="headersTemplate"
											:items="pendingTemplates"
											:items-per-page="20"
											class="light table mx-4 pending-table"
											:footer-props="{
										'items-per-page-options': [5, 10, 15]
									}"
										>
											<template v-slot:item.preview="{ item }">
												<v-btn
													color="primary"
													label
													small
													@click="showPreview(item.templateID)"
												>
												{{item.preview}}
													Preview
													<v-icon right small>fas fa-eye</v-icon>
												</v-btn>
											</template>
											<!-- <template v-slot:item.templateApproved="{ item }">
												<span :class="item.templateApproval === 1 ? 'success--text' : 'error--text'">
													{{ item.templateApproval === 1 ? 'Approved' : 'Not Approved' }}
												</span>
											</template> -->
										</v-data-table>
									</v-tab-item>
									<v-tab-item key="completedTemplate">
										<v-card-title class="text-center justify-left py-6">
											<h3 class="darkColor--text">Completed Onsite Templates</h3>
										</v-card-title>
										<v-data-table
											:loading="loading"
											theme--
											light
											:headers="headersTemplate"
											:items="completedTemplates"
											:items-per-page="20"
											class="light table mx-4 pending-table"
											:footer-props="{
										'items-per-page-options': [5, 10, 15]
									}"
										>
											<template v-slot:item.preview="{ item }">
												<v-btn
													color="primary"
													label
													small
													@click="showPreview(item.templateID)"
												>
												{{item.preview}}
													Preview
													<v-icon right small>fas fa-eye</v-icon>
												</v-btn>
											</template>
										</v-data-table>
									</v-tab-item>
								</v-tabs>
								<br />
							</v-card>
						</v-col>
					</v-row>
                    <br />
                </v-tab-item>
				<v-tab-item>
					<br>
					<v-row>
						<v-col>
							<v-card elevation="0" outlined>
								<v-tabs background-color="transparent" color="orangeButton" v-model="onsiteAudits">
									<v-tab key="pendingaudits">
										Pending 
									</v-tab>
									<v-tab key="completedaudits">
										Completed
									</v-tab>
									<v-tab-item key="pendingaudits">
										<v-card elevation="0">
											<v-card-title class="text-center justify-left py-6">
												<h3 class="darkColor--text">Pending Onsite-Audits</h3>
											</v-card-title>
											<v-data-table
												:loading="loading"
												theme--
												light
												:headers="headersPending"
												:items="pendingaudits"
												:items-per-page="20"
												class="light table mx-4 pending-table"
												:footer-props="{
											'items-per-page-options': [5, 10, 15]
										}"
											>
												<template v-slot:item.onsiteDate="{ item }">
													<span v-if="item.visitDays && item.onsiteDate">
														{{ item.onsiteDate }}
														<v-tooltip top>
															<template v-slot:activator="{ on, attrs }">
																<span
																	v-bind="attrs"
																	v-on="on"
																	class="grey--text text--darken-1"
																>
																	({{ item.visitDays }} days)
																</span>
															</template>
															<span>Number of visit days</span>
														</v-tooltip>
													</span>
													<span v-else>
														{{ item.onsiteDate }}
													</span>
												</template>
												<template v-slot:item.actions="{ item }">
													<v-btn
														color="primary"
														label
														small
														@click="showHintDialog(item)"
													>
														View
														<v-icon right small>far fa-eye</v-icon>
													</v-btn>
												</template>
												<template v-slot:item.schedule="{ item }">
													<v-btn
														:to="'/auditonsite/onsiteauditor/schedule/'+item.id"
														:color="item.scheduleSubmitted ? 'success' : 'primary'"
														label
														small
													>
														{{ item.scheduleSubmitted ? 'View' : 'Create' }}
														<v-icon right small>
															{{ item.scheduleSubmitted ? 'fas fa-eye' : 'fa-solid fa-pen-to-square' }}
														</v-icon>
													</v-btn>
												</template>
												<template v-slot:item.complete="{ item }">
													<v-btn
														:to="'/auditonsite/onsiteauditor/'+item.id"
														color="primary"
														label
														small
													>
														{{item.complete}}
														Complete
														<v-icon right small>fas fa-pencil-alt</v-icon>
													</v-btn>
												</template>
											</v-data-table>
											<br />
										</v-card>
										<br />
									</v-tab-item>
									<v-tab-item key="completedaudits">
										<v-card elevation="0">
											<v-card-title class="text-center justify-left py-6">
												<h3 class="darkColor--text">Completed Onsite-Audit</h3>
											</v-card-title>
											<v-data-table
												:loading="loading"
												theme--
												light
												:headers="headersCompleted"
												:items="completedaudits"
												:items-per-page="20"
												class="light table mx-4 completed-table"
												:footer-props="{
											'items-per-page-options': [5, 10, 15]
										}"
											>
												<template v-slot:item.onsiteDate="{ item }">
													<span v-if="item.visitDays && item.onsiteDate">
														{{ item.onsiteDate }}
														<v-tooltip top>
															<template v-slot:activator="{ on, attrs }">
																<span
																	v-bind="attrs"
																	v-on="on"
																	class="grey--text text--darken-1"
																>
																	({{ item.visitDays }} days)
																</span>
															</template>
															<span>Number of visit days</span>
														</v-tooltip>
													</span>
													<span v-else>
														{{ item.onsiteDate }}
													</span>
												</template>
												<template v-slot:item.view="{ item }">
													<v-btn
														:to="'/auditonsite/onsiteaudits/'+item.id"
														color="primary"
														label
														small
													>
														{{item.view}}
														View
														<v-icon right small>far fa-eye</v-icon>
													</v-btn>
												</template>
											</v-data-table>
											<br />
										</v-card>
									</v-tab-item>
								</v-tabs>
								<br />
							</v-card>
						</v-col>
					</v-row>
                    
                    <br />
                </v-tab-item>
            </v-tabs>
        </v-row>
		<v-dialog 
			v-model="dialogPreview"
			max-width="1200px"
			height="auto"
			scrollable
			align = "center">
			<v-card>
				<v-card-actions class="pt-7 pr-8" style="justify-content: flex-end">
					<v-btn 
						class="success"
						color="white" 
						text 
						@click="closePreview()" 
						outlined
					>Close</v-btn
					>
				</v-card-actions>
				<v-card-text class="background-color: white">
					<v-col v-if="isEdited && !templateApproved" class="orange"><h2 style="color: white">Template was edited according to your comments</h2></v-col>
					<v-col v-if="shouldDisableButtons && !templateApproved" class="orange"><h2 style="color: white">Already sent your feedback</h2></v-col>
					<v-col v-if="templateApproved" class="success"><h2 style="color: white">You already Approved this template</h2></v-col>
					<template-preview v-if="preview"
						:previewID="templateID"
						:preview="true"
					/>
					<v-divider class="my-5"></v-divider>
					<h2 class="mb-3 darkColor--text">Comments</h2>
					<v-textarea
						v-model="comments"
						outlined
						label="Add your comments here"
						placeholder="If there any changes or notes about this template to modify please enter them here."
						rows="4"
						class="mb-4"
					></v-textarea>
					<v-btn :disabled="shouldDisableButtons" color="primary" @click="saveComments()" class="ml-0"> Save Comments </v-btn>
					<v-btn :disabled="shouldDisableButtons" color="primary" @click="approveTemplate()" class="ml-3"> Approve</v-btn>
				</v-card-text>
			</v-card>
		</v-dialog>
		<v-dialog v-model="dialogHint" max-width="500">
            <v-card style="border: 1px solid black;">
                <v-card-title>Onsite Audit Scope:</v-card-title>
                <v-card-text>
                    <div v-if="selectedItem">
                        <p v-if="selectedItem.hint"><strong>Objective and Scope:</strong> {{ selectedItem.hint }}</p>
						<p v-else><i>There is no any details about your onsite-Audit</i></p>
                    </div>
                </v-card-text>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn color="primary" text @click="dialogHint = false">Close</v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
    </v-container>
</template>

<script>
import TemplatePreview from "./OnsiteTemplatePreview.vue"
import TemplateRequestAPI from "../../api/audit/template"
import AuditRequestsAPI from "../../api/audit/request"
import AuditsAPI from "../../api/audit/audit"
import LoadingState from "../../consts/LoadingState"
import { mapGetters } from "vuex"
export default {
	name: "AuditorAuditOnsiteOverview",
	components: {
		"template-preview" : TemplatePreview,
	},
	data() {
		return {
			headersTemplate: [
				{
					text: "Sender",
					value: "sender",
					sortable: false,
					class: "darkColor--text"
				},
				{
					text: "Audit Template",
					value: "templateName",
					sortable: false,
					class: "darkColor--text"
				},
				{
					text: "Timestamp",
					value: "timestamp",
					sortable: false,
					class: "darkColor--text"
				},
				{
					text: "Preview",
					value: "preview",
					sortable: false,
					class: "darkColor--text"
				},
				/* {
					text: "Approved",
					value: "templateApproved",
					sortable: false,
					class: "darkColor--text"
				}, */
			],
			headersPending: [
				{
					text: "Sender",
					value: "sender",
					sortable: false,
					class: "darkColor--text",
					width: "100px"
				},
				{
					text: "Supplier",
					value: "supplierName" || "invitationCodeName",
					sortable: false,
					class: "darkColor--text"
				},
				{
					text: "Timestamp",
					value: "timestamp",
					sortable: false,
					class: "darkColor--text"
				},
				{
					text: "Onsite-Date",
					value: "onsiteDate",
					sortable: false,
					class: "darkColor--text"
				},
				{
					text: "Audit Template",
					value: "template",
					sortable: false,
					class: "darkColor--text"
				},
				{
					text: "Objective & Scope",
					value: "actions",
					sortable: false,
					align: "center",
					class: "darkColor--text"
				},
				{
					text: "Schedule",
					value: "schedule",
					sortable: false,
					align: "center",
					class: "darkColor--text"
				}
			],

			headersCompleted: [
				{
					text: "Sender",
					value: "recipient",
					sortable: false,
					class: "darkColor--text"
				},
				{
					text: "Supplier",
					value: "supplier",
					sortable: false,
					class: "darkColor--text"
				},
				{
					text: "Timestamp",
					value: "timestamp",
					sortable: false,
					class: "darkColor--text"
				},
				{
					text: "Onsite-Date",
					value: "onsiteDate",
					sortable: false,
					class: "darkColor--text"
				},
				{
					text: "Audit Template",
					value: "template",
					sortable: false,
					class: "darkColor--text"
				},
				{
					text: "View",
					value: "view",
					sortable: false,
					class: "darkColor--text"
				},
			],

			pendingaudits: [],
			completedaudits: [],
			id: false,
			client: false,
			timestamp: false,
			template: false,
			dialogDelete: false,
			loading: false,
			templateApprovals: [],
			dialogPreview: false,
			preview: false,
			templateID: null,
			comments: "",
			templateApproved: 0,
			isEdited: false,
			getComment: [],
			selectedItem: null,
			dialogHint: false,
			onsiteTemplates: "pendingTemplate",
			onsiteAudits: "pendingaudits"
		}
	},
	mounted() {
		this.loadPendingAudits()
		this.loadCompletedAudits()
		this.loadPreviewTemplate()
		let createAccess = this.$accessToOperation("AU", "C")
		if (createAccess) {
			this.headersPending.push(
				{
					text: "Complete",
					value: "complete",
					sortable: false,
					class: "secondary--text"
				}
			)
		}
	},
	computed: {
		...mapGetters("user", ["isLoggedIn", "getUser"]),
		username() {
			return this.getUser.username
		},
		shouldDisableButtons() {
			if (this.templateApproved === 1) return true
			if (Array.isArray(this.getComment) && this.getComment.length > 0) {
				const lastComment = this.getComment[this.getComment.length - 1]
				if (lastComment.fixed !== 1) return true
			}
			return false
		},
		pendingTemplates() {
			return this.templateApprovals.filter(template => template.templateApproval === 0)
		},
		completedTemplates() {
			return this.templateApprovals.filter(template => template.templateApproval === 1)
		}
	},
	methods: {
		showHintDialog(item) {
			this.selectedItem = item
			this.dialogHint = true
		},
		closePreview(){
			this.dialogPreview = false
			this.preview = false
			window.location.reload()
		},
		loadTemplateApproval(){
			TemplateRequestAPI.getTemplateComment(this.templateID)
				.then(result => {
					if (result.length > 0) {
						this.templateApproved = result[0].TemplateApproval
						this.getComment = JSON.parse(result[0].Comment)
						if (Array.isArray(this.getComment)) {
							const lastComment = this.getComment[this.getComment.length - 1]
							this.isEdited = lastComment.fixed === 1

							if (lastComment.fixed !== 1 && lastComment.comment) {
								this.comments = lastComment.comment
							}
						}
					}
				})
				.catch(reason => {
					this.$store.dispatch(
						"loading/" + LoadingState.ACTION_SET_ERROR,
						reason,
						{ root: true }
					)
				})
		},
		approveTemplate(){
			const approved = true
			this.$store.dispatch("loading/" + LoadingState.ACTION_START_LOADING, null,{ root: true })

			TemplateRequestAPI.onsiteTemplateApprove(this.templateID, approved)
				.then(() => {
					this.$store.dispatch(
						"loading/" + LoadingState.ACTION_LOADING_SUCCESS,
						`Successfully approve the template`,
						{ root: true }
					)
					this.dialogPreview = false
				})
				.catch(error => {
					this.error = error
					this.$store.dispatch(
						"loading/" + LoadingState.ACTION_SET_ERROR,
						error,
						{ root: true }
					)
				})
			window.location.reload()
		},
		saveComments(){
			this.$store.dispatch("loading/" + LoadingState.ACTION_START_LOADING, null,{ root: true })
			TemplateRequestAPI.updateTemplateComment(this.templateID, this.comments)
				.then(() => {
					this.$store.dispatch(
						"loading/" + LoadingState.ACTION_LOADING_SUCCESS,
						`Successfully add a comment for onsite-audit template`,
						{ root: true }
					)
					this.dialogPreview = false
				})
				.catch(error => {
					this.error = error
					this.$store.dispatch(
						"loading/" + LoadingState.ACTION_SET_ERROR,
						error,
						{ root: true }
					)
				})
			window.location.reload()
		},
		showPreview(templateId) {
			this.templateID = templateId
			this.preview = true
			this.dialogPreview = true
			this.loadTemplateApproval()
		},
		loadCompletedAudits() {
			this.$store.dispatch(
				"loading/" + LoadingState.ACTION_START_LOADING,
				null,
				{ root: true }
			)
			const user = this.$store.getters["user/getUser"]
			AuditsAPI.onsiteList({type: "outgoing"})
				.then(result => {
					this.completedaudits = []
					for (let entry of result.items) {
						if(entry.allowFlowDown ===0 && entry.allowOnsite ==1 && (user.username === entry.sender)){
							let onsiteDate
							if(entry.fromDate && entry.toDate){
								onsiteDate = this.$moment(entry.fromDate).format("DD/MM/YYYY") + " - " + this.$moment(entry.toDate).format("DD/MM/YYYY")
							}else if(entry.fromDate){
								onsiteDate = this.$moment(entry.fromDate).format("DD/MM/YYYY")
							}else if(entry.toDate){
								onsiteDate = this.$moment(entry.toDate).format("DD/MM/YYYY")
							}
							this.completedaudits.push({
								id: entry.id,
								recipient: entry.recipientName,
								timestamp: this.$moment(entry.timestamp).format("DD/MM/YYYY HH:mm:ss"),
								template: entry.templateName,
								supplier: entry.recipientUsername || entry.supplierName,
								onsiteDate: onsiteDate,
								visitDays: entry.visitDays ?? null,
								view: null,
								
							})
						}
					}
					this.$store.dispatch(
						"loading/" + LoadingState.ACTION_END_LOADING,
						null,
						{ root: true }
					)
				})
				.catch(reason => {
					this.$store.dispatch(
						"loading/" + LoadingState.ACTION_SET_ERROR,
						reason,
						{ root: true }
					)
				})
		},
		/* loadPendingAudits() {
			let createAccess = this.$accessToOperation("AU", "C")
			this.$store.dispatch(
				"loading/" + LoadingState.ACTION_START_LOADING,
				null,
				{ root: true }
			)
			const user = this.$store.getters["user/getUser"]
			AuditRequestsAPI.onsiteList({type:"outgoing"})
				.then(result => {
					this.pendingaudits = []
					for (let entry of result.items) {
						let onsiteDate
						if(entry.fromDate && entry.toDate){
							onsiteDate = this.$moment(entry.fromDate).format("DD/MM/YYYY") + " - " + this.$moment(entry.toDate).format("DD/MM/YYYY")
						}else if(entry.fromDate){
							onsiteDate = this.$moment(entry.fromDate).format("DD/MM/YYYY")
						}else if(entry.toDate){
							onsiteDate = this.$moment(entry.toDate).format("DD/MM/YYYY")
						}
						if(user.username === entry.auditor){
							this.pendingaudits.push({
								id: entry.requestID,
								sender: entry.senderName || entry.sender || entry.invitationCodeName,
								timestamp: this.$moment(entry.timestamp).format("DD/MM/YYYY HH:mm:ss"),
								template: entry.templateName,
								onsiteDate: onsiteDate,
								supplierName: entry.recipientName || entry.invitationCodeName,
								complete: createAccess ? null : undefined
							})
						}
					}
					this.$store.dispatch(
						"loading/" + LoadingState.ACTION_END_LOADING,
						null,
						{ root: true }
					)
				})
				.catch(reason => {
					this.$store.dispatch(
						"loading/" + LoadingState.ACTION_SET_ERROR,
						reason,
						{ root: true }
					)
				})
		}, */
		loadPendingAudits(){
			let createAccess = this.$accessToOperation("AU", "C")
			this.$store.dispatch(
				"loading/" + LoadingState.ACTION_START_LOADING,
				null,
				{ root: true }
			)
			AuditRequestsAPI.pendingAuditorlist()
				.then(result => {
					this.pendingaudits = []
					const schedulePromises = result.items.map(entry => {
						return AuditsAPI.getSchedule(entry.requestID)
							.then(scheduleResult => {
								let onsiteDate
								if(entry.fromDate && entry.toDate){
									onsiteDate = this.$moment(entry.fromDate).format("DD/MM/YYYY") + " - " + this.$moment(entry.toDate).format("DD/MM/YYYY")
								}else if(entry.fromDate){
									onsiteDate = this.$moment(entry.fromDate).format("DD/MM/YYYY")
								}else if(entry.toDate){
									onsiteDate = this.$moment(entry.toDate).format("DD/MM/YYYY")
								}
								
								return {
									id: entry.requestID,
									sender: entry.senderName || entry.sender || entry.invitationCodeName,
									timestamp: this.$moment(entry.timestamp).format("DD/MM/YYYY HH:mm:ss"),
									template: entry.templateName,
									onsiteDate: onsiteDate,
									visitDays: entry.visitDays ?? null,
									supplierName: entry.recipientUsername || entry.recipientName || entry.invitationCodeName,
									hint: entry.hint,
									scheduleSubmitted: Array.isArray(scheduleResult) && scheduleResult.length > 0, // Check if schedule exists
									complete: createAccess ? null : undefined
								}
							})
					})

					// Wait for all schedule checks to complete
					Promise.all(schedulePromises)
						.then(audits => {
							this.pendingaudits = audits
							this.$store.dispatch(
								"loading/" + LoadingState.ACTION_END_LOADING,
								null,
								{ root: true }
							)
						})
				})
				.catch(reason => {
					this.$store.dispatch(
						"loading/" + LoadingState.ACTION_SET_ERROR,
						reason,
						{ root: true }
					)
				})
		},
		loadPreviewTemplate(){
			this.$store.dispatch(
				"loading/" + LoadingState.ACTION_START_LOADING,
				null,
				{ root: true }
			)
			TemplateRequestAPI.getTemplateRequest()
				.then(result => {
					this.templateApprovals = []
					for (let entry of result) {	
						this.templateApprovals.push({
							templateID: entry.TemplateID,
							sender: entry.Sender,
							templateName: entry.TemplateName,
							timestamp: this.$moment(entry.Timestamp).format("DD/MM/YYYY HH:mm:ss"),
							timestampRaw: entry.Timestamp,
							preview: null,
							templateApproval: entry.TemplateApproval
						})
						
					}
					this.templateApprovals.sort((a, b) => {
						return new Date(b.timestampRaw) - new Date(a.timestampRaw)
					})
					this.$store.dispatch(
						"loading/" + LoadingState.ACTION_END_LOADING,
						null,
						{ root: true }
					)
				})
				.catch(reason => {
					this.$store.dispatch(
						"loading/" + LoadingState.ACTION_SET_ERROR,
						reason,
						{ root: true }
					)
				})
		}
	}
}
</script>
<style>
.completed-table thead th {
    font-size: 14px !important;
}
.pending-table thead th {
    font-size: 14px !important;
}
</style>
